module.exports = __webpack_public_path__ + "static/media/toddler-group.1bfeac13.svg";